import React from 'react';
import Layout from '../components/Layout';

export default () => (
  <Layout>
    <h1>First paint on Feb 3, 2020</h1>
  </Layout>
);
